import "core-js/modules/es.array.concat";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
export function throttle(func, wait) {
  var timeout;
  return function () {
    var that = this;
    var args = arguments;

    if (!timeout) {
      timeout = setTimeout(function () {
        timeout = null;
        func.apply(that, args);
      }, wait);
    }
  };
}
/**
 * 利用 document.title 做新消息提示
 * @export
 * @param {Number} count
 */

export function titleNotify(count) {
  var hasNewMessage = count > 0;

  if (hasNewMessage) {
    if (document.title.search(/\((.*?)\)/) >= 0) {
      document.title = document.title.replace(/\((.*?)\)/, "(".concat(count > 99 ? '99+' : count, ")"));
    } else {
      document.title = "(".concat(count, ")").concat(document.title);
    }
  } else {
    document.title = document.title.replace(/\((.*?)\)/, '');
  }
}